module.exports = __webpack_public_path__ + "static/img/アセット 26@2x.5b7be3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_history/アセット 26@2x.png
// module id = EBdu
// module chunks = 1